var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPnl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bxp45h9nja",
    d: "M0 0h15.008v31.948H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ugawla74fc",
    d: "M0 0h3.758v11.299H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.438 14.676c0-.237.006-.394-.001-.55-.024-.544-.448-.965-.954-.953-.501.012-.902.424-.92.956-.009.28-.013.562.002.842.01.183-.056.262-.226.337-1.122.495-1.81 1.732-1.62 2.886.24 1.476 1.271 2.38 2.806 2.464.403.022.69.217.843.587.148.36.08.698-.18.983-.264.287-.598.362-.97.26-.4-.108-.679-.386-.954-.674-.375-.391-.94-.422-1.316-.084-.396.354-.42.91-.054 1.338a4.9 4.9 0 0 0 .835.747c.262.193.693.208.806.506.11.291.019.657.029.989.016.543.44.968.946.96.499-.007.904-.418.926-.95.01-.238.022-.48-.003-.716-.026-.262.06-.394.308-.512 1.082-.517 1.72-1.725 1.539-2.844-.24-1.473-1.268-2.376-2.807-2.463-.403-.023-.69-.218-.842-.589a.874.874 0 0 1 .16-.96c.264-.302.606-.385.992-.282.3.08.53.272.763.467.416.35.973.31 1.316-.076.325-.367.3-.93-.065-1.295-.245-.244-.514-.477-.838-.585-.451-.15-.647-.402-.521-.79zM32 20.533c-.13.467-.169.952-.302 1.421a8.515 8.515 0 0 1-7.238 6.132c-4.454.506-8.545-2.555-9.276-6.94-.782-4.692 2.41-9.083 7.098-9.768 4.537-.664 8.797 2.427 9.606 6.96.034.19-.003.398.112.573v1.622z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.557)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ybbbl9lvpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bxp45h9nja"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.756 31.948c0-8.047 0-16.093.007-24.14 0-.265-.073-.325-.328-.32-.812.017-1.625.008-2.438.006-.469-.002-.793-.221-.939-.628-.138-.384-.03-.76.32-1.06 2.149-1.84 4.3-3.68 6.452-5.519.447-.381.903-.384 1.351-.001 1.607 1.37 3.21 2.745 4.816 4.118.553.473 1.115.937 1.659 1.422.582.519.414 1.387-.3 1.628-.124.042-.246.04-.37.04-.803 0-1.605.01-2.407-.006-.252-.005-.337.05-.331.318.019.832 0 1.664.012 2.495.003.205-.065.302-.244.405-3.054 1.747-4.873 4.355-5.308 7.846-.517 4.139 1.604 8.156 5.3 10.181.196.107.257.222.251.433-.013.519-.029 1.04.002 1.558.035.573-.154.99-.693 1.224H3.756z",
    fill: "#FFF",
    opacity: 0.4,
    mask: "url(#ybbbl9lvpb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.688 31.948V14.297c0-.783.338-1.124 1.113-1.124.76 0 1.521.012 2.28-.006.277-.007.363.056.363.35-.01 5.977-.008 11.955-.008 17.932l.002.499h-3.75z",
    fill: "#FFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ckoqlis6dd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ugawla74fc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 .695C.231.178.626-.023 1.193.002c.716.032 1.435.023 2.152 0 .312-.01.414.057.413.396-.014 3.633-.008 7.267-.008 10.901H.687A1.338 1.338 0 0 1 0 10.613V.695z",
    fill: "#FFF",
    opacity: 0.4,
    mask: "url(#ckoqlis6dd)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPnl);
export default __webpack_public_path__ + "static/media/ic-pnl.f6acf06d99b1da9196b4207d1aafe211.svg";
export { ForwardRef as ReactComponent };